import { TEXT_SETTINGS, SHAPE_SETTINGS, ITEXT } from '../constants';

export const getCommonSettings = (obj, type, events, transformObj) => {
  let coords = null;
  if (obj) {
    switch (type) {
      case 'drag':
        coords = {
          ...transformObj,
          x: events.transform.target.left || 0,
          y: events.transform.target.top || 0,
        };
        break;
      case 'rotate':
        coords = {
          ...transformObj,
          angle: events.target.angle || 0,
          x: events.transform.target.left || 0,
          y: events.transform.target.top || 0,
        };
        break;
      case 'scaleX':
        coords = {
          ...transformObj,
          x: events.transform.target.left || 0,
          y: events.transform.target.top || 0,
          scaleX: Math.abs(events.target.scaleX || 1),
          width: obj.width,
          height: obj.height,
        };
        break;
      case 'scaleY':
        coords = {
          ...transformObj,
          x: events.transform.target.left || 0,
          y: events.transform.target.top || 0,
          scaleY: Math.abs(events.target.scaleY || 1),
          width: obj.width,
          height: obj.height,
        };
        break;
      case 'scale':
        coords = {
          ...transformObj,
          x: events.transform.target.left || 0,
          y: events.transform.target.top || 0,
          scaleX: Math.abs(events.target.scaleX || 1),
          scaleY: Math.abs(events.target.scaleY || 1),
          width: obj.width,
          height: obj.height,
        };
        break;
      default:
        coords = {
          x: obj.left,
          y: obj.top,
          width: obj.width,
          height: obj.height,
          angle: obj.angle,
          scaleX: obj.scaleX,
          scaleY: obj.scaleY,
        };
        break;
    }
  }
  return coords;
};

export const getSettingsObj = (type, obj) => {
  let settings = null;
  if (type) {
    switch (type) {
      case ITEXT:
        TEXT_SETTINGS.map((item) => {
          if (item.type === 'group-button' && item.list) {
            item.list.map((i) => {
              settings[i.action] = obj[i.action];
              return settings;
            });
          } else {
            settings = {
              ...settings,
              [item.action]: obj[item.action],
            };
          }
          return settings;
        });
        break;
      default:
        SHAPE_SETTINGS.map((item) => {
          settings = {
            ...settings,
            [item.action]: obj[item.action],
          };
          return settings;
        });
        break;
    }
  }
  return settings;
};
